import React from 'react'
import { CardBody, Container, Row, Col } from 'reactstrap'
import ButtonPrevWithLine from './ButtonPrevWithLine'
import RangeSlider from './RangeSlider'
import ButtonNextWithLine from './ButtonNextWithLine'
import ButtonPrev from './ButtonPrev'
import ButtonNext from './ButtonNext'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actionCreators from '../redux/actions'
import DatePicker from 'react-date-picker'
import { calculateAge } from '../utils/calculations'
function Slide3 ({ onNextRequested, onPrevRequested, onIncrementProgress, onDecrementProgress, age, numOfChildren, youngestChildAge, set, dateOfBirth }) {
  const setSelected = (event) => {
    const selectedGender = document.querySelector('.btn-gender.selected')
    if (selectedGender) {
      selectedGender.classList.remove('selected')
    }
    event.target.classList.add('selected')
    set('gender', event.currentTarget.dataset.val)
  }

  const youngestChildSliderOpts = {
    maxValue: 25,
    minValue: 0,
    youngestChildSliderValue: youngestChildAge,
    valueKey: 'youngestChildAge'
  }

  const childrenSliderOpts = {
    maxValue: 10,
    minValue: 0,
    childrenSliderValue: numOfChildren,
    valueKey: 'numOfChildren'
  }

  const slideThreeSvg = `/assets/people.svg`

  const onPrevClick = () => {
    onDecrementProgress()
    onPrevRequested()
  }

  const onNextClick = () => {
    onIncrementProgress()
    onNextRequested()
  }

  const onDatePickerChange = (date) => {
    // if there is no value, they cleared the date picker
    // set date to empty string (default state value)
    // which will in turn set the age in the calculate age function to its default
    if (!date) date = ''
    set('dateOfBirth', date)
    set('age', calculateAge(date))
  }

  return (
    <CardBody className='Slide3 app-slide w-100'>
      <Container fluid style={{ padding: 0 }}>
        <Row >
          <Col xs={{ size: 12, order: 1 }} xl={{ order: 1, size: 6, push: 1 }} className='mt-xl-5 pt-xl-5'>
            <div className='d-flex align-items-center justify-content-between flex-direction-row pr-xl-2 flex-wrap'>
              <div className='mr-xl-5 center-block m-auto'>
                <img alt='' src={slideThreeSvg} className='img-fluid' />
              </div>
              <div className='card-text col-xl-7 text-left mt-3'>
                <h2 className='mr-xl-5 h2-sized-down'>Tell us about yourself.</h2>
                <h2 className='mr-xl-5 h2-sized-down'>  Who depends on you?</h2>
                <p className='col-xs-12 text-left mr-xl-5'>Input your age, gender, date of birth, and any dependents you have.</p>
              </div>
            </div>
          </Col>
          <Col xs={{ size: 12, order: 1 }} xl={{ order: 1, size: 5 }} className='mt-xl-5 pt-xl-5'>
            <div className='d-xl-flex d-none pull-left' style={{ width: 1, height: 1, position: 'relative', left: 50 }}>
              <ButtonPrevWithLine onClick={onPrevClick} />
            </div>
            <div className='d-xl-flex d-none' style={{ width: 1, height: 1, position: 'relative', left: 650 }}>
              <ButtonNextWithLine onClick={onNextClick} />
            </div>
            <div className='ml-xl-5 p-xl-4 d-flex justify-content-between flex-wrap date-row' style={{ height: 100 }}>
              <h4 className='h4-slider-label text-nowrap mr-2 text-xl-right text-sm-center d-sm-block' style={{ maxWidth: 100 }}>YOUR DATE OF BIRTH</h4>
              <DatePicker
                onChange={onDatePickerChange}
                value={dateOfBirth}
                className='ml-xl-3 mr-xl-3 pt-1 col-xl-9' />
            </div>
            <div className='ml-xl-5  p-xl-4 d-inline-flex justify-content-between flex-wrap' style={{ height: 120 }}>
              <h4 className='h4-slider-label text-nowrap mr-xl-2 text-xl-right text-sm-center d-sm-block' style={{ position: 'relative', top: 10 }}>YOUR GENDER</h4>
              <div className='button-selection d-flex ml-xl-3 align-items-start'>
                <button className='btn btn-gender' onClick={setSelected} data-val='Female'>FEMALE</button>
                <button className='btn btn-gender selected' onClick={setSelected} data-val='Male'>MALE</button>
              </div>
            </div>
            <div className='ml-xl-5  p-xl-4 d-flex justify-content-between flex-wrap' style={{ height: 90 }}>
              <h4 className='h4-slider-label text-xl-right text-sm-center mr-2 d-sm-block' >CHILDREN</h4>
              <RangeSlider
                maxValue={childrenSliderOpts.maxValue}
                minValue={childrenSliderOpts.minValue}
                updateRange={set}
                valueKey={childrenSliderOpts.valueKey}
                value={childrenSliderOpts.childrenSliderValue}
                className='ml-xl-3  mr-xl-3 pt-1 col-xl-9' />
            </div>
            <div className='ml-xl-5  p-xl-4 d-flex justify-content-between flex-wrap' style={{ height: 100 }}>
              <h4 className='h4-slider-label text-wrap text-xl-right text-sm-center  mr-2 d-sm-block' style={{ maxWidth: 100, overflowWrap: `initial` }} >YOUNGEST CHILD'S AGE</h4>
              <RangeSlider
                maxValue={youngestChildSliderOpts.maxValue}
                minValue={youngestChildSliderOpts.minValue}
                updateRange={set}
                valueKey={youngestChildSliderOpts.valueKey}
                value={youngestChildSliderOpts.youngestChildSliderValue}
                className='ml-xl-3 mr-xl-3 pt-1 col-xl-9' />
            </div>
          </Col>
        </Row>
        <Row>
          <div className='d-flex justify-content-between d-xl-none mt-5 col-12' style={{ position: 'relative', left: 0 }}>
            <div style={{ position: 'relative', left: 20 }}>
              <ButtonPrev onClick={onPrevClick} />
            </div>
            <div style={{ position: 'relative', right: 20 }}>
              <ButtonNext onClick={onNextClick} />
            </div>
          </div>
        </Row>
      </Container>
    </CardBody>
  )
}

const mapStateToProps = (state) => ({
  age: state.app.age,
  gender: state.app.gender,
  numOfChildren: state.app.numOfChildren,
  youngestChildAge: state.app.youngestChildAge,
  dateOfBirth: state.app.dateOfBirth
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Slide3)
